import { Injectable, isDevMode } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as fromAuth from '../../auth/reducers';
import * as fromBase from '../../base/reducers';
import { Title } from '@angular/platform-browser';

import * as _ from 'lodash'

@Injectable()
export class TenantService {
  tenantName$: Observable<string>
  customCssUrl = ''
  customFaviconUrl = ''
  domain = window.location.host.split('.')[0]
  fullDomain = window.location.host

  constructor(private store: Store<any>,
              private titleSvc: Title) {

    this.store.pipe(select(fromBase.getAppName))
      .subscribe((appName) => {
        this.titleSvc.setTitle(appName)
      })

    this.tenantName$ = this.store
      .pipe(
        select(fromBase.getTenantCode)
      )

    this.tenantName$
      .subscribe(tenantName => {

        if (tenantName) {
          const formattedTenantName = tenantName.replace(/\s/g, '').toLowerCase()
          if (isDevMode()) {
            this.customCssUrl = `https://orderfield.blob.core.windows.net/tenant/${formattedTenantName}/custom.css`
          } else {
            this.customCssUrl = `https://cdn1.orderfield.com/tenant/${formattedTenantName}/custom.css`
          }
          this.customFaviconUrl = `https://cdn1.orderfield.com/tenant/${formattedTenantName}/favicon.ico`
        } else if (_.includes(this.domain, 'localhost')) {
          this.customCssUrl = ''
          this.customFaviconUrl = '/assets/tenant/favicon.ico'
        } else if (this.fullDomain === 'webshop.manen.nl') {
          this.customCssUrl = `https://cdn1.orderfield.com/tenant/vanmanen/custom.css`
          this.customFaviconUrl = `https://cdn1.orderfield.com/tenant/vanmanen/favicon.ico`
        } else {
          this.customCssUrl = `https://cdn1.orderfield.com/tenant/${this.domain}/custom.css`
          this.customFaviconUrl = `https://cdn1.orderfield.com/tenant/${this.domain}/favicon.ico`
        }

        const interval = setInterval(() => {
          const customCss = document.getElementById('customCss')
          const customFavicon = document.getElementById('favicon')
          if (customCss && customFavicon) {
            customCss.setAttribute('href', this.customCssUrl)
            customFavicon.setAttribute('href', this.customFaviconUrl)
            clearInterval(interval)
          }
        }, 200)

      })

    setTimeout(() => this.removeGlobalLoader(), 1500)
  }

  get currentDomain() {
    return `${this.domain.charAt(0).toUpperCase()}${this.domain.slice(1)}`
  }

  removeGlobalLoader() {
    document.getElementById('main').classList.remove('loading')
  }
}
